<template>
  <div>
    <card-toolbar
      :title="$tc('about')"
    />

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row no-gutters class="pt-6 pb-0" justify="center">
        <v-col cols="12" class="text-center">
          <p>
            <strong>{{ 'HSM Console ' + new Date().getFullYear() + ' Dinamo Networks v' + version + ' - built with Vuetify' }}</strong>
          </p>
        </v-col>
        <v-col cols="12" class="text-center">
          <p>
            <a class="text_secondary--text" href="https://docs.dinamonetworks.com/" target="_blank">
              {{ $tc('technical_documentation') }}
            </a>
            <v-icon small @click="openLink('https://docs.dinamonetworks.com/')">
              open_in_new
            </v-icon>
          </p>
        </v-col>
        <v-col cols="12" class="mt-1 text-center">
          <v-row class="mb-2">
            <template v-for="(item, key) in infoItens">
              <template v-if="item.data !== null && item.data !== ''">
                <v-col
                  cols="12"
                  :md="item.id === 'copyright_heading' ? 12 : 6"
                  :key="`tab-item-${key}`"
                  v-if="item.data !== null && item.data !== ''"
                  class="pa-2 py-0"
                >
                  <span
                    class="subtitle-1 font-weight-medium"
                    :id="`title-${item.id}`"
                  >
                    {{ item.title }}
                  </span>
                  <template v-if="Array.isArray(item.data)">
                    <v-row no-gutters class="pt-8" :class="{'hide-in-percy': item.hideFromPercy}">
                      <v-col cols="12" md="6" :id="`subVal-${item.id}`" v-for="subitem in item.data" :key="subitem" :class="item.class">
                        <template v-if="subitem !== null && subitem !== ''">
                          {{ subitem }}
                        </template>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-else>
                    <div :class="{'hide-in-percy': item.hideFromPercy}">
                      <p :id="`val-${item.id}`" v-if="item.html" v-html="item.data" :class="item.class" />
                      <p :id="`val-${item.id}`" v-if="!item.html" class="subtitle-1">
                        {{ item.data }}
                      </p>
                    </div>
                  </template>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'

export default {
  components: { CardToolbar },
  created: async function () {
    await this.makeRequests()
    this.softwares = await this.$store.state.hsm.copyrightInfo
  },
  data () {
    return {
      softwares: null
    }
  },
  computed: {
    version () {
      return this.$store.state.ui.version
    },
    infoItens () {
      const items = []

      items.push(
        {
          title: this.$tc('copyright_heading'),
          data: this.softwares,
          id: 'copyright_heading'
        }
      )

      return items
    }
  },
  methods: {
    openLink (link) {
      window.open(link)
    },
    async makeRequests () {
      await this.$store.dispatch('hsm/getCopyrightInfo')
    }
  }
}
</script>
